import { render, staticRenderFns } from "./ActivityDigest.vue?vue&type=template&id=a2c55836&scoped=true&lang=html&"
import script from "./ActivityDigest.vue?vue&type=script&lang=js&"
export * from "./ActivityDigest.vue?vue&type=script&lang=js&"
import style0 from "./ActivityDigest.vue?vue&type=style&index=0&id=a2c55836&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2c55836",
  null
  
)

export default component.exports